import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppCommonCoreModule } from '@common/app-common-core.module';
import { HighlightPipe } from '@common/pipes/highlight.pipe';
import { FaqHeaderPipe } from '@common/pipes/faqheader.pipe';
import { FaqContentPipe } from '@common/pipes/faqcontent.pipe';
import { AbsoluteNumberPipe } from '@common/pipes/absolute-number.pipe';
import { ParamReplacementPipe } from '@common/pipes/param-replacement-pipe';
import { CmsTextPipe } from '@common/pipes/cms-text.pipe';
import { CmsImageSrcPipe } from '@common/pipes/cms-image-src.pipe';
import { CmsImageAltPipe } from '@common/pipes/cms-image-alt.pipe';
import { YouTubePipe } from '@common/pipes/youtube.pipe';
import { ContentComponent } from '@common/components/content/content.component';
import { CommandComponent } from '@common/components/command/command.component';
import { ErrorComponent } from '@common/components/error/error.component';
import { ContactOptionsComponent } from '@common/components/contact-options/contact-options.component';
import { CmsKeysBarComponent } from '@common/components/cms-keys-bar/cms-keys-bar.component';
import { SocialnetworkIconsComponent } from '@common/components/socialnetwork-icons/socialnetwork-icons.component';
import { FocusFirstInvalidFieldDirective } from '@common/directives/focus-invalid.directive';
import { RouteTransformerDirective } from '@common/directives/route-tranformer.directive';
import { HighlightDirective } from '@common/directives/highlight.directive';
import { InputRegexDirective } from '@common/directives/input-regex.directive';
import { GoogleAnalyticsEventDirective } from '@common/directives/ga-event.directive';
import { YoutubeMovieDirective } from '@common/directives/youtube.movie.directive';
import { ContentTooltipExtComponent } from '@common/components/content-tooltip-ext/content-tooltip-ext.component';
import { EncodeURIComponentPipe } from '@common/pipes/encode-url-component.pipe';
import { CmsKeyOptSuffixPipe } from '@common/pipes/cms-key-optional-suffix.pipe';
import { VwoVariantPipe } from '@common/pipes/vwo-variant.pipe';
import { MiniFaqComponent } from '@common/components/mini-faq/mini-faq.component';
import { VwoCapturerComponent } from '@common/components/vwo/vwo-capturer.component';
import { FeedbackSurveyComponent } from '@common/components/feedback-survey/feedback-survey.component';
import { ProposalInteractionEventDirective } from '@common/analytics/directives/proposal-interaction-event.directive';
import { ClickEventDirective } from '@common/analytics/directives/click-event.directive';
import { ContainsYoutubeDirective } from '@common/directives/contains-youtube.directive';


@NgModule({
    imports: [
        CommonModule,
        AppCommonCoreModule,
    ],
    exports: [
        HttpClientModule,
        NgbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HighlightPipe,
        FaqHeaderPipe,
        FaqContentPipe,
        ParamReplacementPipe,
        CmsTextPipe,
        CmsImageSrcPipe,
        CmsImageAltPipe,
        CmsKeyOptSuffixPipe,
        YouTubePipe,
        AbsoluteNumberPipe,
        EncodeURIComponentPipe,
        ContentComponent,
        CommandComponent,
        ErrorComponent,
        ContactOptionsComponent,
        CmsKeysBarComponent,
        ContentTooltipExtComponent,
        FocusFirstInvalidFieldDirective,
        RouteTransformerDirective,
        HighlightDirective,
        InputRegexDirective,
        GoogleAnalyticsEventDirective,
        YoutubeMovieDirective,
        ContainsYoutubeDirective,
        SocialnetworkIconsComponent,
        VwoVariantPipe,
        MiniFaqComponent,
        VwoCapturerComponent,
        FeedbackSurveyComponent,
        ProposalInteractionEventDirective,
        ClickEventDirective
    ]
})
export class SharedModule { }
